import { render, staticRenderFns } from "./ArrowForward.vue?vue&type=template&id=5de1abf5&scoped=true&"
import script from "./ArrowForward.vue?vue&type=script&lang=js&"
export * from "./ArrowForward.vue?vue&type=script&lang=js&"
import style0 from "./ArrowForward.vue?vue&type=style&index=0&id=5de1abf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de1abf5",
  null
  
)

export default component.exports